import { put, takeEvery, call } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    SET_GLOBAL_VARIABLES,
    EDIT_GLOBAL_VARIABLES,
    GET_GLOBAL_VARIABLES,
} from 'store/key';
import { produce } from 'utility/general';
import API from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';

const initialState = {
    isLoading: false,
    globalVariablesList: [],
};

function* getSystemVariable(action) {
    yield put({
        type: SET_GLOBAL_VARIABLES,
        payload: {
            isLoading: true,
        }
    });
    try {
        const res = yield call(API.system.getSystemVariable, {});
        yield put({
            type: SET_GLOBAL_VARIABLES,
            payload: {
                globalVariablesList: res.data.result,
            }
        });
    } catch (err) {
        console.log("global variables's error: ", err);
    };
    yield put({
        type: SET_GLOBAL_VARIABLES,
        payload: {
            isLoading: false,
        }
    });
};

function* editGlobalVariables(action) {
    const { id, data, callback } = action.payload;

    setGlobalLoading(true);
    try {
        const res = yield call(API.system.updateSystemVariable, { id, data });
        
        if (res.status === 200) {
            callback?.();
        }
    } catch (err) {
        console.log("global variables's error: ", err);
    };
    setGlobalLoading(false);
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GLOBAL_VARIABLES:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchGlobalVariables() {
    yield takeEvery(EDIT_GLOBAL_VARIABLES, safeSaga(editGlobalVariables));
    yield takeEvery(GET_GLOBAL_VARIABLES, safeSaga(getSystemVariable));
}

export default reducer;
